
import { defineComponent, ref } from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { Modal } from "bootstrap";

import ApiService from "@/core/services/ApiService";

import CsvFieldMapModal from "./CsvFieldMapModal.vue";
import ImportCsvModal from "./ImportCsvModal.vue";

export default defineComponent({
  name: "realestate-import-modals-container",
  components: {
    ImportCsvModal,
    CsvFieldMapModal,
  },
  props: {},
  setup() {
    const store = useStore();
    const isLoading = ref<boolean>(false);
    const isCompleted = ref<boolean>(false);
    // eslint-disable-next-line
    const originalData = ref<any[]>([]);

    const dataFields = ref<any[]>([]);
    const fileName = ref("");

    const handleCompletedImport = async (param, name) => {
      fileName.value = name;
      originalData.value = param;
      if (originalData.value) {
        dataFields.value = originalData.value[0];
      }

      try {
        const res = await ApiService.post(
          `dev/realestate?action=match_headers`,
          originalData.value[0]
        );

        if (res.data.success) {
          const fieldMap = JSON.parse(res.data.data);
          await submitFields(fieldMap);
          return;
        }
      } catch (e) {
        console.log(e);
      }

      const fieldMapModal = new Modal(
        document.getElementById("kt_modal_realestate_fieldmap")
      );
      fieldMapModal.show();
    };

    const submitFields = async (fieldMap) => {
      isLoading.value = true;
      const data: any = [];

      originalData.value.slice(1).map((row) => {
        const arg = {};

        Object.keys(fieldMap).forEach((headerAligned) => {
          if (fieldMap[headerAligned] !== null) {
            const index = originalData.value[0].findIndex(
              (header) => header === fieldMap[headerAligned]
            );
            if (row[index]) {
              arg[headerAligned] = row[index];
            } else {
              arg[headerAligned] = "";
            }
          } else {
            arg[headerAligned] = "";
          }
        });

        data.push(arg);
      });

      try {
        const res = await ApiService.post(
          `dev/realestate?action=insert_file&file_name=${fileName.value}`,
          data
        );

        if (res.data.success) {
          Swal.fire({
            text: "You have successfully created the merchant!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            isCompleted.value = true;
          });
        } else {
          Swal.fire({
            text: res.data.data.error
              ? res.data.data.error[0]
              : "Something went wrong!",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }

      isLoading.value = false;
    };

    const handleFieldMap = async (param) => {
      isLoading.value = true;

      if (param !== null) {
        let fieldsmap = {
          FullSiteAddress: null,
          SiteAddressHouseNumber: null,
          SiteAddressStreetPrefix: null,
          SiteAddressStreetName: null,
          SiteAddressUnitNumber: null,
          SiteAddressCity: null,
          SiteAddressState: null,
          SiteAddressZip: null,
          "SiteAddress+4": null,
          SiteCarrierRoute: null,
          Owner1FirstName: null,
          Owner1MiddleName: null,
          Owner1LastName: null,
          Owner1SpouseFirstName: null,
          Owner2FirstName: null,
          Owner2MiddleName: null,
          Owner2LastName: null,
          Owner2SpouseFirstName: null,
          MailAdressStreetNumber: null,
          MailAddressStreetPrefix: null,
          MailAddressStreetName: null,
          MailAddressUnitNumber: null,
          MailAddressCity: null,
          MailAddressState: null,
          MailAddressZip: null,
          "MailAddress+4": null,
          MailCarrierRoute: null,
          OwnerOccupied: null,
          UseCodeDescription: null,
          UseCodeCounty: null,
          Zoning: null,
          BuildingSqft: null,
          Rooms: null,
          Bedrooms: null,
          Bathrooms: null,
          Pool: null,
          NumberofStories: null,
          NumberofUnits: null,
          SalesPrice: null,
          SalesPriceCode: null,
          SaleDate: null,
          SalesDocumentNumber: null,
          AssessedLandValue: null,
          AssessedImprovePercent: null,
          AssessedImprovementValue: null,
          EstValue: null,
          EstEquity: null,
          ListedforSale: null,
          PrimaryPhone1: null,
          PrimaryMobilePhone1: null,
          PrimaryEmail1: null,
          PrimaryPhone1Hash: null,
          PrimaryEmail1Hash: null,
          SecondaryPhone1: null,
          SecondaryMobilePhone1: null,
          SecondaryPhone1Hash: null,
          SecondaryEmail1: null,
          SecondaryEmail1Hash: null,
          LotAreaAcres: null,
          LotAreaSQFT: null,
          ParcelNumber: null,
          YearBuilt: null,
          GarageNumberofCars: null,
          GarageType: null,
          Tract: null,
          TaxExemptionCode: null,
          TaxDelinquent: null,
          TaxDelinquentYears: null,
          TaxYear: null,
          View: null,
          CostPerSqFt: null,
          DeedType: null,
          TaxArea: null,
          TaxAmount: null,
          LoanAmount: null,
          LoanAmount2nd: null,
          LoanType: null,
          LenderName: null,
          TitleCompanyName: null,
          PriorSaleDate: null,
          PriorSalesPrice: null,
          Latitude: null,
          Longitude: null,
          SellerAgent: null,
          SellerAgentCompany: null,
          BuyerAgent: null,
          BuyerAgentCompany: null,
          CensusTract: null,
        };
        const dbVsCsvMap = {};

        param.forEach((group) => {
          if (group.item !== "") {
            if (originalData.value) {
              let index = originalData.value[0].findIndex(
                (header) => header === group.item
              );
              fieldsmap[group.name] = index;
            }

            dbVsCsvMap[group.name] = group.item;
          }
        });

        await ApiService.post(`dev/realestate`, dbVsCsvMap);

        // eslint-disable-next-line
        let data: any = [];

        originalData.value.slice(1).map((row) => {
          let arg = {};

          Object.keys(fieldsmap).forEach((headerAligned) => {
            if (fieldsmap[headerAligned] !== null) {
              if (row[fieldsmap[headerAligned]]) {
                arg[headerAligned] = row[fieldsmap[headerAligned]];
              } else {
                arg[headerAligned] = "";
              }
            } else {
              arg[headerAligned] = "";
            }
          });

          data.push(arg);
        });

        try {
          const res = await ApiService.post(
            `dev/realestate?action=insert_file&file_name=${fileName.value}`,
            data
          );

          if (res.data.success) {
            Swal.fire({
              text: "You have successfully created the merchant!",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(function () {
              isCompleted.value = true;
            });
          } else {
            Swal.fire({
              text: res.data.data.error
                ? res.data.data.error[0]
                : "Something went wrong!",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          }
        } catch (e) {
          Swal.fire({
            text: e.response.data.error
              ? e.response.data.error.message
              : "Something went wrong!",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      }

      isLoading.value = false;
    };

    return {
      originalData,
      isLoading,
      isCompleted,
      handleFieldMap,
      handleCompletedImport,
      dataFields,
    };
  },
});
